import { Controller } from "@hotwired/stimulus"

// 同意モーダルのチェックボックス状態に応じて submit ボタンの活性/非活性を切り替える
// Connects to data-controller="agreement-modal"
export default class extends Controller<HTMLFormElement> {
  static targets = ["checkbox", "submit"]

  declare readonly checkboxTarget: HTMLInputElement
  declare readonly submitTarget: HTMLInputElement | HTMLButtonElement

  toggle(): void {
    this.submitTarget.disabled = !this.checkboxTarget.checked
  }
}
